var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center py-3"},[_c('div',{staticClass:"flex-shrink-0"},[_c('img',{attrs:{"src":`${_vm.assetsBaseUrl}/media.ashx?${_vm.item.productImage}&template=product-icon`}})]),_c('div',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }